import Game from "./engine/game";
import ScreenStack from "./interface/screen-stack";
import Gamepad from "./engine/gamepad";

const game = Game.start();
window.debug = game;

const gamepad = new Gamepad();

const ui = new ScreenStack(game.stage, gamepad);

window.addEventListener("gamepadconnected", (ev) => {
  gamepad.registerInstance(ev.gamepad.index);
}, false);

gamepad.addEventListener("stickpressed", ev => {
  ui.handleGamepadButton(ev);
});

gamepad.addEventListener("buttonpressed", ev => {
  ui.handleGamepadButton(ev);
});

document.addEventListener("keydown", (ev) => {
  ui.handleKeypress(ev);
});

document.addEventListener("ui.transition", ev => {
  ui.handleTransition(ev);
})

document.addEventListener("game.event", ev => {
  ui.handleGameEvent(ev);
});

window.addEventListener("resize", () => {
  ui.rescale();
});

document.addEventListener("click", ev => {
  ui.handleClick(ev);
});

document.addEventListener("contextmenu", ev => {
  ev.preventDefault();
  ui.handleRightClick(ev);
});

function gameLoop() {
  gamepad.poll();
  game.update();
  ui.render();
  requestAnimationFrame(gameLoop);
}

window.addEventListener("load", () => {
  requestAnimationFrame(gameLoop);
});
